import { createPluginFactory } from '@udecode/plate';

export const KEY_COLOR_PICKER_SETTINGS = 'color-picker-settings';

export const createColorPickerSettingsPlugin = createPluginFactory({
  key: KEY_COLOR_PICKER_SETTINGS,
  options: {
    colorPickerProps: {},
  },
});
